import React, { useEffect } from 'react';
import CusDataGrid from '../../../../../components/material-ui/CusDataGrid';
import { useTranslation } from 'react-i18next';

export default function CollectionCasino({
  casinos,
  label = 'Casinos using the collection',
  selectedIds,
  setSelectedIds,
  disableRowSelectionOnClick,
  checkboxSelection,
  readOnlyCheckBox,
  onRowClick
}) {
  const { t } = useTranslation();

  const columns = [
    { field: 'id', headerName: t('ID'), width: 60, headerClassName: 'bold-header' },
    { field: 'name', headerName: t('Name casino'), flex: 1, headerClassName: 'bold-header' }
  ];

  const rows =
    casinos?.map((elCasino) => ({
      id: +elCasino.id,
      name: elCasino.casinoName
    })) || [];

  return (
    <CusDataGrid
      label={label}
      checkboxSelection={checkboxSelection}
      rows={rows}
      columns={columns}
      rowSelectionModel={selectedIds}
      onRowSelectionModelChange={(newSelection) => setSelectedIds(newSelection)}
      onRowClick={onRowClick}
      disableRowSelectionOnClick={disableRowSelectionOnClick}
      readOnlyCheckBox={readOnlyCheckBox}
      sx={{ border: 'none' }}
      labelFontWeight={600}
      maxHeight="calc( 33svh - 100px)"
      minHeight="180px"
    />
  );
}
